import { getLxIds, getLxPoiParams } from './parseAdParams';

let _pageCase = null;

const createLxPageCase = () => {
    if (_pageCase != null) {
        return _pageCase;
    }

    const poiParams = getLxPoiParams();
    const lab = { custom: getLxIds(), ...(poiParams ? { poi_id: poiParams } : {}) };

    const env = null;
    //getPage 是getTracker和pageView命令的语法糖，会发送一条PV事件
    _pageCase =
        LXAnalytics &&
        LXAnalytics('getPage', lab, env, {
            //cid:'xxx', //页面cid，不传，取html模板文件中 LXAnalytics config的默认值
            //category:'xxx' //页面通道，不传，取html模板文件中 LXAnalytics config的默认值
        });

    // 返回pageCase用于页面内部（局部曝光 || 点击等）上报
    return _pageCase;
};
// 默认执行一次，用于上报PV，并缓存_pageCase
createLxPageCase();

/**
 * 通用曝光事件上报
 * @param {*} bid
 * @param {*} valLab
 * @param {*} options
 */
const mv = (bid, valLab = {}, options = {}) => {
    valLab.custom = Object.assign({}, valLab.custom, getLxIds());
    createLxPageCase()('moduleView', bid, valLab, options);
};

/**
 * 通用点击事件上报
 * @param {*} bid
 * @param {*} valLab
 * @param {*} options
 */
const mc = (bid, valLab = {}, options = {}) => {
    valLab.custom = Object.assign({}, valLab.custom, getLxIds());
    createLxPageCase()('moduleClick', bid, valLab, options);
};

/**
 * 列表内条目曝光上报
 * @param {*} bid
 * @param {*} contentPvId
 * @param {*} poiIdStr
 * @param {*} itemIndex
 * @param {*} valLab
 * @param {*} options
 */
const mvItem = (bid, contentPvId = '', poiIdStr = '', itemIndex = '', valLab = {}, options = {}) => {
    valLab.custom = Object.assign({}, valLab.custom, getLxIds(contentPvId));
    if (poiIdStr !== '') {
        valLab.poi_id = poiIdStr; //poi_id:数据组使用的通用字段
    }
    if (itemIndex !== '') {
        valLab.item_index = itemIndex; //item_index:数据组使用的通用字段
    }
    createLxPageCase()('moduleView', bid, valLab, options);
};

/**
 * 列表内条目点击上报
 * @param {*} bid
 * @param {*} contentPvId
 * @param {*} poiIdStr
 * @param {*} itemIndex
 * @param {*} valLab
 * @param {*} options
 */
const mcItem = (bid, contentPvId = '', poiIdStr = '', itemIndex = '', valLab = {}, options = {}) => {
    valLab.custom = Object.assign({}, valLab.custom, getLxIds(contentPvId));
    if (poiIdStr !== '') {
        valLab.poi_id = poiIdStr; //poi_id:数据组使用的通用字段
    }
    if (itemIndex !== '') {
        valLab.item_index = itemIndex; //item_index:数据组使用的通用字段
    }
    createLxPageCase()('moduleClick', bid, valLab, options);
};

const oadLX = {
    mv,
    mc,
    mvItem,
    mcItem,
};

export default oadLX;

// html 模板文件配置
// <script>
//     // 定义全局LXAnalytics函数（勿动）
//     !function(c,e,d){c._MeiTuanALogObject=d;if(!c[d]){var a=function(){var b=function(){var a=function(){a.q.push([arguments,+new Date])};a.q=[];b.q.push([arguments,a]);return a};b.q=[];b.t=+new Date;a.q.push([arguments,b]);return b};a.q=a.q||[];a.l=+new Date;c[d]=a}}(window,document,"LXAnalytics");

//     //初始化配置
//     LXAnalytics('config', {
//         defaultCategory:'waimai', //页面默认通道
//         appName:'offsite_ad',   //页面应用名
//         defaultCid: 'c_waimai_4p6w08bm', //默认页面cid //TODO cid需要修改
//         autoTrack: false,  //是否开启部分事件自动埋点，预计在二期实现
//         isSPA: true,   //是否是单页面应用
//         mvDelay: 0 , //合并mv事件的缓存秒数，0为关闭
//         onWebviewAppearAutoPV: true, //在app内嵌页时，容器显示/隐藏时的自动PV/PD开关
//         onVisibilityChangeAutoPV: true, //在pc端，切换tab页签时的自动PV/PD开关
//         onWindowFocusAutoPV: true, //在pc端，当window获得/失去焦点时的自动PV/PD开关
//         onVCGap: 2, //pc端切换tab、window失焦时，间隔多久切回来才会触发自动PV/PD。最小有效值2，单位秒
//         sessionScope:'top', //session种在一级域下还是当前域下，默认top为一级域，sub为当前域
//         nativeReport:'on' //是否开启app内嵌页代报
//     });

// </script>
// <script src="//lx.meituan.net/lx.5.min.js"></script>
